import { ReactNode } from 'react';
import { useTheme } from '@mui/material';
import { TextLDefaultWrapper } from './styles';

export interface ITextLDefaultProps
  extends React.HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  weight?: 'regular' | 'bold' | 'semibold' | 'medium';
}

const fontWeightTypes = {
  regular: 'Rg',
  bold: 'B',
  semibold: 'Sb',
  medium: 'Md',
};

const TextL = ({
  children,
  weight = 'regular',
  ...props
}: ITextLDefaultProps) => {
  const theme = useTheme();
  return (
    <TextLDefaultWrapper
      weight={weight}
      {...props}
      style={{
        ...props.style,
        fontWeight: theme.typography?.fontWeight?.[fontWeightTypes[weight]],
      }}
    >
      {children}
    </TextLDefaultWrapper>
  );
};

export default TextL;
